import { http } from '@/services/http_service';
export default{
    registerAttendance(context, data)
    {
        //앞단에서 받아서 판별이 필요하기 때문에 return
        return http()
        .post("/attendance/store", data)
        .then((response) => {
            //console.log(response.data);
            if(response.data.attendance !=0)
            {
                context.commit('addAttendance', response.data.attendance)
            }
            return response.data;
        },function(error){
            console.log(error.response.data);
        });
    },
    fetchLists(context, data)
    {
        return http()
        .post("/attendance/fetchLists?page="+data.page, data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //console.log("출석체크넘겨받은 데이터 확인",data);
            context.commit('setAttendance', response.data.attendance.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
}
